import * as React from "react"
import { useSignal } from "@preact/signals-react";
import { Box, Typography } from "@mui/material"

import { ImageSkuBlock } from "@components";
import {IAOptionsSelectedStyles, IAOptionsStyles} from "./@styles";
import { SkuInfoBlockWrap } from "../@components/Table/@components";
import { brandForm, countryForm, fillCommonFormValue, siteForm, skuForm } from "../@signals";


export default function AdminProductReviewFormIACardsOptions({ IAOptionsData }) {
    const selectedIdx = useSignal(null)
    const initialSkuForm = useSignal(null)
    const initialBrandForm = useSignal(null)

    const handleClick = (idx, element) => {
        if (selectedIdx.value === null) {
            initialSkuForm.value = skuForm.value
            initialBrandForm.value = brandForm.value
        }
        if (selectedIdx.value === idx) {
            selectedIdx.value = null
            fillCommonFormValue({
                countryForm: countryForm.value,
                siteForm: siteForm.value,
                brandForm: initialBrandForm.value,
                skuForm: initialSkuForm.value
            })
        } else {
            selectedIdx.value = idx
            fillCommonFormValue({
                countryForm: countryForm.value,
                siteForm: siteForm.value,
                brandForm: element.brandID,
                skuForm: element.skuID
            })
        }

    }

    return <Box > 
        <Typography sx={{ mb: 3 }}>Options Suggested By IA</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            {IAOptionsData.map((element, idx) => 
                <Box key={idx} sx={selectedIdx.value === idx ? IAOptionsSelectedStyles : IAOptionsStyles} onClick={() => handleClick(idx, element)}>
                    <ImageSkuBlock 
                        skuID={element?.skuID}
                        skuName={element.skuName} 
                        sx={{ margin: '', marginRight: 3, width: '100px' }}
                        height={100}
                        hideName
                    />
                    <SkuInfoBlockWrap 
                        sku={element.skuName} 
                        category={element.category} 
                        brand={element.brand} 
                        maxWidthEllipsis={600}
                    />
                </Box>
            )}
        </Box>
    </Box>

}